export const features = {
  title: "Solicitudes de funcionalidades",
  subtitle:
    "Contribuí al ecosistema de Araria y enviá tu solicitud de funcionalidad, o votá por funcionalidades existentes.",
  subtitle2:
    "¡Tu opinión es muy importante para nosotros. Votá por lo que es más importante para vos!",
  voteCount: "Votos",
  approve: "Aprobar",
  edit: "Editar",
  create: "Crear",
  votes: "Votos",
  unvote: "Quitar voto",
  vote: "Votar",
  filter: "Filtrar por estado",
  showMore: "Ver más",
  showLess: "Ver menos",
  statusFlow: "Flujo de Ejecución",
  statusFlowDescription:
    "Las funcionalidades siguen este flujo desde el envío hasta la finalización.",
  status: {
    ALL: "Todas las funcionalidades",
    PENDING: "Pendiente",
    PENDING_DESC: "Esperando análisis por parte del administrador",
    APPROVED: "Aprobado",
    APPROVED_DESC:
      "Aprobado por el administrador, abierto para votaciones de usuarios",
    REJECTED: "Rechazado",
    REJECTED_DESC:
      "Rechazado por el administrador, no se abrirá para votaciones, pero podemos decidir reabrirlo para votaciones en el futuro",
    PLANNED: "Planificado",
    PLANNED_DESC:
      "Planificado para una versión futura, pero no está en desarrollo",
    IN_PROGRESS: "En progreso", // Or "En desarrollo"
    IN_PROGRESS_DESC: "En desarrollo",
    PAUSED: "Pausado",
    PAUSED_DESC: "Pausado temporalmente, pero no descartado",
    COMPLETED: "Completado",
    COMPLETED_DESC: "Completado y disponible para todos los usuarios",
    DECLINED: "Declinado", // Or "Rechazado" (if you want to be consistent)
    DECLINED_DESC: "Se decidió no incluir esta funcionalidad",
  },
  modal: {
    title: "Crear solicitud de funcionalidad",
    titleEdit: "Editando solicitud de funcionalidad",
    titleLabel: "Título",
    titlePlaceholder: "Ingresá el título de la funcionalidad",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Ingresá la descripción de la funcionalidad",
    statusLabel: "Estado",
    isPublished: "Hacer público",
    submit: "Enviar",
    update: "Actualizar",
    note: "Esta funcionalidad pasará por el administrador. Si se aprueba, será visible para todos los usuarios que podrán votar por ella.",
  },
  error: {
    voting: "Error al enviar el voto.",
    loading: "Error al cargar las funcionalidades.",
    creating: "Error al crear la solicitud de funcionalidad.",
    updating: "Error al actualizar la solicitud de funcionalidad.",
  },
  success: {
    created: "Solicitud de funcionalidad creada correctamente.",
    updated: "Solicitud de funcionalidad actualizada correctamente.",
  },
};
